/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EfsMelcoEfsModelsUserFormatListItem,
    EfsMelcoEfsModelsUserFormatListItemFromJSON,
    EfsMelcoEfsModelsUserFormatListItemFromJSONTyped,
    EfsMelcoEfsModelsUserFormatListItemToJSON,
    EfsMelcoModelsCustomWarning,
    EfsMelcoModelsCustomWarningFromJSON,
    EfsMelcoModelsCustomWarningFromJSONTyped,
    EfsMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface EfsMelcoModelsGenericList1MelcoEfsModelsUserFormatListItem
 */
export interface EfsMelcoModelsGenericList1MelcoEfsModelsUserFormatListItem {
    /**
     * 
     * @type {Array<EfsMelcoEfsModelsUserFormatListItem>}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsUserFormatListItem
     */
    list: Array<EfsMelcoEfsModelsUserFormatListItem>;
    /**
     * 
     * @type {Array<EfsMelcoModelsCustomWarning>}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsUserFormatListItem
     */
    warning_list?: Array<EfsMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsUserFormatListItem
     */
    total: number;
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsUserFormatListItemFromJSON(json: any): EfsMelcoModelsGenericList1MelcoEfsModelsUserFormatListItem {
    return EfsMelcoModelsGenericList1MelcoEfsModelsUserFormatListItemFromJSONTyped(json, false);
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsUserFormatListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoModelsGenericList1MelcoEfsModelsUserFormatListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(EfsMelcoEfsModelsUserFormatListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(EfsMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsUserFormatListItemToJSON(value?: EfsMelcoModelsGenericList1MelcoEfsModelsUserFormatListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(EfsMelcoEfsModelsUserFormatListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(EfsMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


